import useSessionProvider from 'providers/SessionProvider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from 'use-http';
const Unsubscribe = () => {
    const { survey, sessionId, channel } = useSessionProvider();
    const { i18n } = useTranslation();
    const { post } = useFetch(process.env.REACT_APP_API_URL);
    useEffect(() => {
        document.body.classList.remove('body--survey');
    }, []);
    useEffect(() => {
        if (sessionId !== -1 && channel) {
            post('/Customer/Unsubscribe', {
                session_id: sessionId,
                channel
            })
                .then((res) => {
                    console.log({ res });
                })
                .catch((err) => {
                    console.log({ err });
                });
        }
    }, [sessionId, channel, post]);
    return (
        <div className="container container-md">
            <div className="thank-you">
                <div className="thankyou__image">
                    {survey?.unsubscribePage?.banner && (
                        <img src={survey?.unsubscribePage?.banner} alt="Unsubscribe Banner" />
                    )}
                </div>
                <div className="thankyou__content">
                    <div className="thankyou--icon ">
                        <i className="fa-light fa-envelope-open"></i>
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: survey?.unsubscribePage?.text[i18n.language] }}></div>
                </div>
            </div>
            <div className="thankyou--footer">
                <div className="thankyou--footer">
                    {survey?.unsubscribePage?.social && (
                        <ul className="social-list">
                            {survey?.unsubscribePage?.social &&
                                survey.unsubscribePage?.twitter &&
                                survey?.unsubscribePage?.twitterUrl && (
                                    <li>
                                        <a
                                            className="twitter"
                                            href={survey?.unsubscribePage?.twitterUrl}
                                            target="_blank"
                                            rel="noreferrer">
                                            <i className="fa-brands fa-twitter"></i>
                                        </a>
                                    </li>
                                )}
                            {survey?.unsubscribePage?.social &&
                                survey.unsubscribePage?.youtube &&
                                survey?.unsubscribePage?.youtubeUrl && (
                                    <li>
                                        <a
                                            className="youtube"
                                            href={survey?.unsubscribePage?.youtubeUrl}
                                            target="_blank"
                                            rel="noreferrer">
                                            <i className="fa-brands fa-youtube"></i>
                                        </a>
                                    </li>
                                )}
                            {survey?.unsubscribePage?.social &&
                                survey.unsubscribePage?.linkedIn &&
                                survey?.unsubscribePage?.linkedInUrl && (
                                    <li>
                                        <a
                                            className="linkedin"
                                            href={survey?.unsubscribePage?.linkedInUrl}
                                            rel="noreferrer"
                                            target="_blank">
                                            <i className="fa-brands fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                )}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Unsubscribe;
